module.exports = __webpack_public_path__ + "img/3人教练.89adbf26.png";